import { useQuery } from "@tanstack/react-query";

import { getAdminShop, getShopId } from "../core/retailShop.core";

export default function useAdminShop() {
  const shopId = getShopId();

  const { data } = useQuery({
    enabled: shopId !== null,
    queryFn: () => getAdminShop(),
    queryKey: ["shopId", shopId],
  });

  return data;
}
